import MuiCardActionArea, { CardActionAreaProps as MuiCardActionAreaProps } from '@mui/material/CardActionArea';
import React, { FC } from 'react';
import { BpDesignSystem } from '../../types';

export type CardActionAreaProps = BpDesignSystem.PropsWithChildren<MuiCardActionAreaProps & {}>;

export const CardActionArea: FC<CardActionAreaProps> = ({ dataTest, ...props }) => (
  <MuiCardActionArea data-test={dataTest} {...props} />
);
